"use client"

import styled from "@emotion/styled"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
} from "@mui/material"
import Image from "next/image"
import React from "react"
import Container from "ui/Container"
import ArrowDown from "ui/icons/ArrowDown"
import { sharedColors } from "ui/theme/colors"
import {
  extractProperty,
  getNonUmbracoUrl,
  Link,
  replaceRichTextLinks,
} from "utils"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

const StyledAccordion = styled(Accordion)`
  background-color: ${sharedColors.white};
  border-radius: 16px !important;
  margin: 0 !important;
  width: 100%;
  padding-bottom: 24px;
  padding-top: 24px;
  box-shadow: none !important;
  &::before {
    display: none;
  }

  .MuiAccordionSummary-root {
    padding: 0 !important;
    height: fit-content !important;
    min-height: 0 !important;
    &:focus-visible {
      border: 1px dashed white;
      outline-offset: 2px;
      outline: 2px solid black;
    }
  }

  .MuiAccordionSummary-content {
    margin: 0 !important;
  }

  .MuiAccordionDetails-root {
    padding: 16px 0 0 0 !important;
    display: flex;
    flex-direction: column;
    gap: 16px;
    ${({ theme }) => theme.breakpoints.up("md")} {
      flex-direction: row;
    }
  }

  .Mui-expanded {
    margin: 0 !important;
  }
`

const TopBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`

const StyledButton = styled(Button)`
  flex-shrink: 0;
  width: max-content;
`

const StyledTypography = styled(Typography)`
  p {
    margin: 0;
  }
`

type Props = {
  data: any
  blockIndex?: number
  isHomepage?: boolean
}

export default function EmergencyUpdate({ data, blockIndex, isHomepage }: Props) {
  const [expanded, setExpanded] = React.useState<boolean>(true)
  const icon = extractProperty(data, "icon")
  const title = extractProperty(data, "title")
  const content = extractProperty(data, "content")
  const button = extractProperty(data, "button")
  const buttonName = button?.[0]?.name
  const buttonUrl = button?.[0]?.url
  const onChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded((el) => !el)
  }
  const isGray = isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1
  return (
    <OuterContainer $isGray={isGray}>
      <Container paddingMobile>
      <StyledAccordion expanded={expanded} onChange={onChange}>
        <AccordionSummary expandIcon={<ArrowDown />}>
          <TopBox>
            <Image alt="" src={icon} width={26} height={26} />
            <Typography variant="body2" fontWeight={700}>
              {title}
            </Typography>
          </TopBox>
        </AccordionSummary>
        <AccordionDetails>
          <StyledTypography
            component={"div"}
            variant="body2"
            style={{ flexGrow: 1 }}
            dangerouslySetInnerHTML={{
              __html: replaceRichTextLinks(content) || "",
            }}
          />
          {buttonName && (
            <StyledButton
              href={getNonUmbracoUrl(buttonUrl)}
              LinkComponent={Link}
              variant="primary"
            >
              <Typography variant="body4" color="white" fontWeight={700}>
                {buttonName}
              </Typography>
            </StyledButton>
          )}
        </AccordionDetails>
      </StyledAccordion>
      </Container>
    </OuterContainer>
  )
}
